module.exports = __webpack_public_path__ + "assets/img/pay-success-icon.cbbc3c16.png";